/** 仅查询本人当前活动的原领取记录，不接受领取或资金写入依赖。 */
export function createActivityClaimHistory({ read, getToken, changed }) {
  let generation = 0, subject = '', id = '', token = '', enabled = false;
  let state = { rows: [], total: 0, pageNumber: 0, loading: false, error: '', loggedIn: false };
  const publish = patch => { state = { ...state, ...patch }; changed?.({ ...state }); };
  const validId = value => /^[1-9]\d*$/.test(String(value)) && Number.isSafeInteger(Number(value));
  const live = scope => enabled && scope.generation === generation && scope.subject === subject && scope.token === getToken();
  async function query(pageNumber) {
    if (!enabled || state.loading || !validId(id) || !token || token !== getToken()) return;
    const scope = { generation, subject, token };
    publish({ loading: true, error: '' });
    try {
      const result = await read({ activityId: Number(id), pageNumber, pageSize: 10 });
      if (!live(scope)) return;
      if (!Array.isArray(result?.data) || !/^\d+$/.test(String(result.total)) || !Number.isSafeInteger(Number(result.total)) || Number(result.total) < 0 || result.data.some(row => !validId(row?.id) || String(row.activityId) !== id)) throw new Error('领取记录响应不一致，请重试');
      const rows = pageNumber === 1 ? [] : state.rows;
      const unique = new Map([...rows, ...result.data].map(row => [String(row.id), row]));
      publish({ rows: [...unique.values()], total: Number(result.total), pageNumber });
    } catch (error) { if (live(scope)) publish({ error: error?.message || '领取记录查询失败，请重试' }); }
    finally { if (live(scope)) publish({ loading: false }); }
  }
  function open(activityId, active = true) {
    generation++; enabled = Boolean(active); id = String(activityId || ''); token = getToken(); subject = `${id}:${token}`;
    publish({ rows: [], total: 0, pageNumber: 0, loading: false, error: '', loggedIn: Boolean(token) });
    if (enabled && token && !validId(id)) { publish({error:'请选择有效活动'}); return; }
    if (enabled && token) return query(1);
  }
  return { open, refresh: () => query(1), more: () => state.rows.length < state.total ? query(state.pageNumber + 1) : undefined, pause() { enabled = false; generation++; publish({ loading: false }); }, snapshot: () => ({ ...state }) };
}

export function claimRecordTime(seconds) {
  const number = Number(seconds);
  if (!Number.isFinite(number) || number <= 0) return '时间待核对';
  return new Date(number * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai', hour12: false });
}
